exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo {\n  float: left; }\n  .Logo svg {\n    height: 22px;\n    display: block;\n    fill: #39a8e4; }\n", ""]);

// exports
